module.exports = __webpack_public_path__ + "img/1503388186.6fb62382.jpg";